import { Pipe, PipeTransform } from '@angular/core';
import { SupplierException } from '../models/supplier-exception';

@Pipe({
  standalone: false,
  name: 'isDeletedException',
  pure: false,
})
export class IsDeletedExceptionPipe implements PipeTransform {
  transform(exceptions: SupplierException[], condition: boolean): any {
    if (!exceptions) return null;
    return exceptions.filter(
      (data: SupplierException) => data.isDeleted == condition
    );
  }
}

